import store from "../store";
import Constants from "../config/constants";
import { serviceEmailBlockedUserList } from "../services/EmailBlocked.service";

export const FETCH_INIT = "FETCH_INIT_EMAIL_BLOCKED_USER";
export const FETCHED = "FETCHED_EMAIL_BLOCKED_USER";
export const FETCHED_FAIL = "FETCHED_FAIL_EMAIL_BLOCKED_USER";
export const FETCHED_FILTER = "FETCHED_FILTER_EMAIL_BLOCKED_USER";
export const FETCH_NEXT = "FETCH_NEXT_EMAIL_BLOCKED_USER";
export const FILTER = "FILTER_EMAIL_BLOCKED_USER";
export const RESET_FILTER = "RESET_FILTER_EMAIL_BLOCKED_USER";
export const SET_SORTING = "SET_SORTING_EMAIL_BLOCKED_USER";
export const SET_FILTER = "SET_FILTER_EMAIL_BLOCKED_USER";
export const SET_PAGE = "SET_PAGE_EMAIL_BLOCKED_USER";
export const CHANGE_PAGE = "CHANGE_PAGE_EMAIL_BLOCKED_USER";
export const CHANGE_STATUS = "CHANGE_STATE_EMAIL_BLOCKED_USER";
export const SET_SERVER_PAGE = "SET_SERVER_PAGE_EMAIL_BLOCKED_USER";
export const CREATE_DATA = "CREATE_EMAIL_BLOCKED_USER";
export const UPDATE_DATA = "UPDATE_EMAIL_BLOCKED_USER";
export const DELETE_ITEM = "DELETE_EMAIL_BLOCKED_USER";
export const RESET_STATE = "RESET_STATE";

export function actionFetchEmailBlockedUserList(index = 1, sorting = {}, filter = {}) {
  const request = serviceEmailBlockedUserList({
    index,
    row: sorting.row,
    order: sorting.order,
    ...filter,
  });
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: SET_FILTER, payload: filter });
      dispatch({ type: SET_SORTING, payload: sorting });
      if (!data.error) {
        dispatch({ type: FETCHED, payload: { data: data.data, page: index } });
        dispatch({ type: SET_SERVER_PAGE, payload: index });
        if (index == 1) {
          dispatch({ type: CHANGE_PAGE, payload: index - 1 });
        }
      } else {
        dispatch({ type: FETCHED_FAIL, payload: null });
      }
    });
  };
}

export function actionChangePageEmailBlockedUserList(page) {
  return (dispatch) => {
    dispatch({ type: CHANGE_PAGE, payload: page });
  };
}

export function actionFilterEmailBlockedUserList(value) {
  const request = null;
  return (dispatch) => {
    dispatch({ type: FETCH_INIT, payload: null });
    request.then((data) => {
      dispatch({ type: FILTER, payload: data });
      dispatch({ type: FETCHED, payload: null });
    });
  };
}

export function actionChangeStatusEmailBlockedUserList(id, status) {
  return (dispatch) => {
    dispatch({ type: CHANGE_STATUS, payload: { id, status } });
  };
}

export function actionResetFilterEmailBlockedUserList() {
  return {
    type: RESET_FILTER,
    payload: null,
  };
}

export function actionResetBlockedUserState() {
  return {
    type: RESET_STATE,
  };
}

export function actionSetPageEmailBlockedUserList(page) {
  const stateData = store.getState().email_blocked_user;
  const currentPage = stateData.currentPage;
  const totalLength = stateData.all.length;
  const sortingData = stateData.sorting_data;
  const query = stateData.query;
  const queryData = stateData.query_data;
  const serverPage = stateData.serverPage;

  if (totalLength <= (page + 1) * Constants.DEFAULT_PAGE_VALUE) {
    store.dispatch(
      actionFetchEmailBlockedUserList(serverPage + 1, sortingData, {
        query,
        query_data: queryData,
      })
    );
  }

  return {
    type: CHANGE_PAGE,
    payload: page,
  };
}
